import { FeatureConfiguration } from "..";
import { MenuSearchReducer } from "./reducers";

export * from "./reducers";

export default function (config: FeatureConfiguration) {
    config.reducers.menuSearch = MenuSearchReducer;
}
